import { render, staticRenderFns } from "./domainListing.vue?vue&type=template&id=0b4afb8e&scoped=true&"
import script from "./domainListing.vue?vue&type=script&lang=js&"
export * from "./domainListing.vue?vue&type=script&lang=js&"
import style0 from "./domainListing.vue?vue&type=style&index=0&id=0b4afb8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4afb8e",
  null
  
)

export default component.exports